export default () => ({
  user_id: parseInt(localStorage.getItem('user_id')) || false,
  username: localStorage.getItem('username') || false,
  token: localStorage.getItem('token') || false,
  token_expires: parseInt(localStorage.getItem('token_expires')) || false,
  refresh_token: localStorage.getItem('refresh_token') || false,
  refresh_token_expires:
    parseInt(localStorage.getItem('refresh_token_expires')) || false,
  status: 'booting',
  password_reset_status: null,
  forgot_password_status: null
})
